import ApiRoutes from "../constants/ApiRoutes";
import Constants from "../constants/Constants";
import ApiClient from "../utilities/api-client";
import ErrorUtils from "../utilities/error-utils";
import AuthenticationService from "./authentication-service";

const TransactionService =  {
    getTransactions : async () => {
        const userDetails = await AuthenticationService.getUserDetails();
        let url;
        if(userDetails?.userRole === Constants.USER_ROLES.EMPLOYEE) {
            url = `${ApiRoutes.EMPLOYEE.ROOT_CONTEXT}${ApiRoutes.EMPLOYEE.TRANSACTIONS}`
        } else if (userDetails?.userRole === Constants.USER_ROLES.VENDOR) {
            url = `${ApiRoutes.VENDORS.ROOT_CONTEXT}${ApiRoutes.VENDORS.DASHBOARD}`
        }
        try {
            const response = await ApiClient.get(url);
            if(response?.data) {
                return response.data;
            }
        } catch (e) {
            throw ErrorUtils.processError(e);
        }
        return null;
    }
}

export default TransactionService;
